import { http } from './client';
import type { FeedbackConfigPatch, FeedbackConfigView } from './types';

export const feedbackConfigApi = {
  async get(botId: string): Promise<FeedbackConfigView> {
    const res = await http.get<FeedbackConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/feedback`,
    );
    return res.data;
  },
  async update(botId: string, patch: FeedbackConfigPatch): Promise<FeedbackConfigView> {
    const res = await http.put<FeedbackConfigView>(
      `/v1/org/bots/${encodeURIComponent(botId)}/feedback`,
      patch,
    );
    return res.data;
  },
};
